/**
 * Authenticated fetch wrapper.
 *
 * Automatically attaches the Firebase bearer token to every request.
 * Use this instead of raw `fetch()` for all API calls.
 */

import { getIdToken } from '../firebase';

const API_BASE = import.meta.env.VITE_API_URL || '';

export async function authedFetch(path: string, init?: RequestInit): Promise<Response> {
  const token = await getIdToken();
  const headers = new Headers(init?.headers);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(`${API_BASE}${path}`, { ...init, headers });
}
